module.exports = __webpack_public_path__ + "img/photoAlbum3.0285ce96.jpg";